var Acre = "أكري";
var Alagoas = "ألاغواس";
var Amazonas = "أمازوناس";
var Bahia = "باهيا";
var Pernambuco = "بيرنامبوكو";
var Roraima = "رورايما";
var Sergipe = "سيرجيبي";
var Tocantins = "توكانتينز";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "أمابا",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "سيارا",
	"Federal District": "القطاع الفدرالي",
	"Espírito Santo": "إسبيريتو سانتو",
	"Goiás": "غوياس",
	"Maranhão": "مارانهاو",
	"Mato Grosso": "ماتو غروسو",
	"Mato Grosso do Sul": "ماتو غروسو دو سول",
	"Minas Gerais": "ميناس جيرايس",
	"Pará": "بارا",
	"Paraíba": "بارايبا",
	"Paraná": "بارانا",
	Pernambuco: Pernambuco,
	"Piauí": "بياوي",
	"Rio de Janeiro": "ريو دي جانيرو",
	"Rio Grande do Norte": "ريو غراندي دو نورت",
	"Rio Grande do Sul": "ريو غراندي دو سول",
	"Rondônia": "روندونيا",
	Roraima: Roraima,
	"Santa Catarina": "سانتا كاتارينا",
	"São Paulo": "ساو باولو",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
